import { render, staticRenderFns } from "./FinanceSalarySliceShowPdf.vue?vue&type=template&id=020fd820&"
import script from "./FinanceSalarySliceShowPdf.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceShowPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports